/* istanbul ignore file */
import ko from 'knockout';
import _ from 'underscore';
import { extractIdsFromIASInput } from '../url-extraction-util';

export default class ViewModel {
  constructor({
    i18n,
    initialImpressionTrackingUrls = [],
    initialIASImpressionTrackingUrlValue = '',
    MaxCountOfImpressionTrackingUrls = 2,
    isImpressionTrackingUrlSectionVisible = true,
    isIASSectionVisible = true,
  }) {
    this.i18n = i18n;
    this.isExpanded = ko.observable(false);
    this.isImpressionTrackingUrlSectionVisible =
      ko.observable(isImpressionTrackingUrlSectionVisible);
    this.isIASSectionVisible =
      ko.observable(isIASSectionVisible);

    this.errorMessage_impressionTrackingUrls = ko.observableArray([]);
    this.errorMessage_verifiedImpressionTracking_IAS = ko.observableArray([]);
    this.impressionTrackingUrlValues = ko
      .observable(this.formatImpressionTrackingUrls(initialImpressionTrackingUrls));
    this.impressionTrackingUrls = ko.pureComputed({
      read: () => this.fixSizeOfImpressionTrackingUrl(
        this.extractUrlsFromRowInput(this.impressionTrackingUrlValues()),
        MaxCountOfImpressionTrackingUrls
      ),
    });

    this.IASImpressionTrackingUrls =
      ko.observableArray(extractIdsFromIASInput(initialIASImpressionTrackingUrlValue));

    this.hasError_impressionTrackingUrls = ko.pureComputed({
      read: () => this.errorMessage_impressionTrackingUrls().length !== 0
        && _.some(this.errorMessage_impressionTrackingUrls(), i => Boolean(i)),
    });

    this.hasError_verifiedImpressionTracking_IAS = ko.pureComputed({
      read: () => this.errorMessage_verifiedImpressionTracking_IAS().length !== 0
        && _.some(this.errorMessage_verifiedImpressionTracking_IAS(), i => Boolean(i)),
    });
  }

  formatImpressionTrackingUrls(urls) {
    if (urls instanceof Array) {
      return urls.join('\n');
    }

    // eslint-disable-next-line no-throw-literal
    throw 'the parameter musht be a Array';
  }

  extractUrlsFromRowInput(input) {
    try {
      return input.split('\n').map(i => i.replace(/\s/g, '')).filter(i => !!i);
    } catch (e) {
      return [];
    }
  }

  fixSizeOfImpressionTrackingUrl(arr, maxcount) {
    while (arr.length < maxcount) {
      arr.push('');
    }

    if (arr.length > maxcount) {
      return arr.slice(0, maxcount);
    }

    return arr;
  }

  setImpressionTrackingUrls(urls) {
    this.impressionTrackingUrlValues(this.formatImpressionTrackingUrls(urls));
  }

  validateImpressionTrackingURLs(urls) {
    this.removeErrors();
    urls.forEach((url) => {
      try {
        const parsedUrl = new URL(url);
        const domain = parsedUrl.hostname;
        const path = parsedUrl.pathname;

        if (domain === 'ad.doubleclick.net' && !path.startsWith('/ddm/trackimp')) {
          this.setErrors([this.i18n.getString('ImpressionTrackingUrls_Error_DoubleClick')]);
        }
      } catch (error) {
        this.setErrors([this.i18n.getString('ImpressionTrackingUrls_Error_InvalidURL')]);
      }
    });
  }

  getImpressionTrackingUrls() {
    return this.impressionTrackingUrls().filter(i => !!i);
  }

  setIASImpressionTrackingUrlValue(value) {
    this.IASImpressionTrackingUrls(value);
  }

  getIASImpressionTrackingUrlValue() {
    return this.IASImpressionTrackingUrls();
  }

  expanderLabel() {
    return this.i18n.getString('ImpressionTrackingUrls_ExpanderLabel');
  }

  setErrors(errors, type = 'ImpressionTrackingUrls') {
    switch (type) {
      case 'ImpressionTrackingUrls':
        if (this.errorMessage_impressionTrackingUrls().length) {
          this.removeErrors('ImpressionTrackingUrls');
        }
        errors.forEach(i => this.errorMessage_impressionTrackingUrls.push(i));
        break;
      case 'VerifiedImpressionTracking_IAS':
        if (this.errorMessage_verifiedImpressionTracking_IAS().length) {
          this.removeErrors('VerifiedImpressionTracking_IAS');
        }
        errors.forEach(i => this.errorMessage_verifiedImpressionTracking_IAS.push(i));
        break;
      default:
    }
  }

  removeErrors(type = 'ImpressionTrackingUrls') {
    switch (type) {
      case 'ImpressionTrackingUrls':
        this.errorMessage_impressionTrackingUrls.removeAll();
        break;
      case 'VerifiedImpressionTracking_IAS':
        this.errorMessage_verifiedImpressionTracking_IAS.removeAll();
        break;
      default:
    }
  }
}
